import store2 from 'store2';
import { LOCAL_STORAGE_NAME } from '../../generator/config/condition';

/**
 * 依頼のあった `data` を storage {@link LOCAL_STORAGE_NAME} へ `JSON.stringify` し保存します
 * @param {string} data 保存対象データ - `state` data - Object は `JSON.stringify` します
 * @param {string} [key=LOCAL_STORAGE_NAME] 保存 storage key name
 * @return {any} undefined 何も返しません
 * @see https://www.npmjs.com/package/store2
 */
const save = (data, key = LOCAL_STORAGE_NAME) => store2.set(key, data);

/**
 * local storage {@link LOCAL_STORAGE_NAME} data を取得します
 * - 取得先で `JSON.parse` が必要で
 * @param {string} [key=LOCAL_STORAGE_NAME] 保存 storage key name
 * @return {store.StoreAPI} local storage {@link LOCAL_STORAGE_NAME} data を返します
 * @see https://www.npmjs.com/package/store2
 */
const get = (key = LOCAL_STORAGE_NAME) => store2.get(key);

/**
 * local storage {@link LOCAL_STORAGE_NAME} data を削除します
 * @param {string} [key=LOCAL_STORAGE_NAME] 保存 storage key name
 * @return {store.StoreAPI}
 */
const remove = (key = LOCAL_STORAGE_NAME) => store2.remove(key);

const has = (key = LOCAL_STORAGE_NAME) => store2.has(key);

export default {
  save,
  get,
  remove,
  has,
};



// WEBPACK FOOTER //
// ./src/phase2/common/storage/index.js